import { apiFetch } from "@/lib/api/client";

export async function getContractPublicUrl(
  storagePathOrReviewId: string | null,
  opts?: { reviewId?: string }
): Promise<string | null> {
  if (!storagePathOrReviewId) return null;

  try {
    if (opts?.reviewId) {
      const { downloadUrl } = await apiFetch<{ downloadUrl: string }>(
        `/api/contracts/${opts.reviewId}/download-url`
      );
      return downloadUrl;
    }

    const { downloadUrl } = await apiFetch<{ downloadUrl: string }>(
      `/api/storage/download-url?path=${encodeURIComponent(storagePathOrReviewId)}&bucket=contracts`
    );
    return downloadUrl;
  } catch {
    return null;
  }
}
